//just a simple class for passing around attack angle and shaft lean values between functions

export default class AA_SL {
    constructor(public attackAngle: string, public shaftLean: string) { };
}

